import { CartItemsDataV2, CartSummaryV2 } from 'thkee-common';

export const cartKeyV2 = 'thk_cart';

export type CartStateV2 = {
  cartId: string;
  cartSummary: CartSummaryV2;
  courses: Array<string>;
  coursesData: Array<CartItemsDataV2>;
};

export const initialCartStateV2: CartStateV2 = {
  cartId: '',
  courses: [],
  coursesData: [],
  cartSummary: {
    subtotal: 0,
    final_total_amount: 0,
    remaining_credit: 0,
    currency: '',
    symbol: '',
    total_discount_amount: 0,
    total_discount_percentage: 0,
    tax_display_type: '',
    prices_include_tax: false,
    hide_zero_tax: false,
    total_tax_amount: 0,
    payable_amount: 0,
    credit_used: 0,
    applied_coupon: [],
    tax_suffix: false,
  },
};
